var map = {
	"./message-cn.json": "QQRH",
	"./message-en.json": "gZsx",
	"./message-jp.json": "rL8M",
	"./message-ko.json": "cBWk",
	"./message-vi.json": "vfJK"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "duHf";


//////////////////
// WEBPACK FOOTER
// ./src/config/i18n ^\.\/message\-.*\.json$
// module id = duHf
// module chunks = 19